import receiveService from "./receive-srvice";
import EncryptUtility from "../../utility/js/encrypt-utility";

export default {
  data() {
    return { assetStatusPoll: null };
  },
  computed: {
    rlpStatus() {
      return this.displayAssetData.find(item => item.label === "RLP Status")?.value || "";
    },
    assetStatusSerial() {
      return this.displayAssetData.find(item => item.label === "Serial Number")?.value || "";
    },
    assetStatusOutOfSync() {
      return /out\s+of\s+sync/i.test(this.rlpStatus);
    },
  },
  watch: {
    rlpStatus: {
      immediate: true,
      handler() {
        this.syncAssetStatusPolling();
      },
    },
    assetStatusSerial() {
      if (this.assetStatusPoll?.serialno !== this.assetStatusSerial) this.stopAssetStatusPolling();
      this.syncAssetStatusPolling();
    },
  },
  mounted() {
    this.syncAssetStatusPolling();
  },
  beforeDestroy() {
    this.stopAssetStatusPolling();
  },
  methods: {
    syncAssetStatusPolling() {
      if (!this.assetStatusOutOfSync || !this.assetStatusSerial) {
        this.stopAssetStatusPolling();
        return;
      }
      if (this.assetStatusPoll) return;
      const poll = { serialno: this.assetStatusSerial, timer: null, pending: false };
      this.assetStatusPoll = poll;
      poll.timer = setInterval(() => this.checkAssetActionStatus(poll), 5000);
      this.checkAssetActionStatus(poll);
    },
    stopAssetStatusPolling() {
      if (this.assetStatusPoll) clearInterval(this.assetStatusPoll.timer);
      this.assetStatusPoll = null;
    },
    async checkAssetActionStatus(poll) {
      if (this.assetStatusPoll !== poll || poll.pending) return;
      if (this.assetStatusSerial !== poll.serialno || !this.assetStatusOutOfSync) {
        this.stopAssetStatusPolling();
        return;
      }
      poll.pending = true;
      try {
        const result = await receiveService.postAssetActionCheckStatus(poll.serialno);
        if (this.assetStatusPoll !== poll || this.assetStatusSerial !== poll.serialno ||
          !this.assetStatusOutOfSync) return;
        const status = result?.status ?? result?.Status;
        const message = result?.message ?? result?.Message;
        if ((status === true || String(status).toLowerCase() === "true") && typeof message === "string") {
          this.displayAssetData = this.displayAssetData.map(item =>
            item.label === "RLP Status" ? { ...item, value: message } : item);
          EncryptUtility.localStorageEncrypt("receiveDisplayAssest", JSON.stringify(this.displayAssetData));
          if (!/out\s+of\s+sync/i.test(message)) this.stopAssetStatusPolling();
        }
      } catch {
        // Transient background failures leave the displayed status unchanged for the next check.
      } finally {
        poll.pending = false;
      }
    },
  },
};
